"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var order_html_1 = __importDefault(require("./order.html"));
var order_controller_1 = __importDefault(require("./order.controller"));
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.instructor.dashboard.order", {
        url: "/order/:order_id",
        controller: order_controller_1.default,
        controllerAs: "vm",
        template: order_html_1.default,
        resolve: {
            order: [
                "$stateParams",
                "OrdersModel",
                function (params, OrdersModel) {
                    return OrdersModel.getDetails({ id: params.order_id }).then(function (response) {
                        response.data.order.payments = response.data.payments;
                        return response.data.order;
                    });
                },
            ],
            billing: [
                "VueStoreFactory",
                function (VueStoreFactory) {
                    return VueStoreFactory.state.auth.policies.policies.find(function (policy) { return policy.name === "billing"; });
                },
            ],
            drives: [
                "VueStoreFactory",
                function (VueStoreFactory) {
                    return VueStoreFactory.state.auth.policies.policies.find(function (policy) { return policy.name === "drives"; });
                },
            ],
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.owner,
                USER_ROLES.instructor,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("instructor.dashboard.order", [])
    .config(config)
    .controller("InstructorOrderController", order_controller_1.default);
